import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044a6118"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar navbar-inverse",
  role: "navigation"
}
const _hoisted_2 = {
  class: "nav navbar-right top-nav",
  style: {"width":"10px"}
}
const _hoisted_3 = { class: "collapse navbar-collapse navbar-ex1-collapse" }
const _hoisted_4 = { class: "nav navbar-nav side-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-brand",
    target: "_blank",
    href: "https://play.eco"
  })
], -1))
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center","margin-bottom":"20px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading...", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  id: "menu-activity",
  class: "",
  "aria-expanded": "true"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-globe" }, null, -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  id: "menu-activity",
  class: "",
  "aria-expanded": "true"
}
const _hoisted_14 = { key: 3 }
const _hoisted_15 = {
  id: "menu-elections",
  "aria-expanded": "true"
}
const _hoisted_16 = {
  id: "current-elected-officials",
  "data-page": "store.elections"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-university" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "localize"
}
const _hoisted_19 = {
  key: 1,
  class: "localize"
}
const _hoisted_20 = { id: "running-elections" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-bar-chart" }, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "localize"
}
const _hoisted_23 = {
  key: 1,
  class: "caret"
}
const _hoisted_24 = {
  key: 2,
  class: "localize"
}
const _hoisted_25 = {
  id: "menu-running-elections",
  class: "running-elections-wrapper collapse in",
  "aria-expanded": "true"
}
const _hoisted_26 = {
  key: 0,
  class: "fa fa-exclamation-circle",
  style: {"color":"red"},
  "data-toggle": "tooltip",
  "data-container": "body",
  "data-placement": "right",
  title: "You have not voted on this issue."
}
const _hoisted_27 = { id: "previous-elections" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-check-square-o" }, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "localize"
}
const _hoisted_30 = {
  key: 1,
  class: "caret"
}
const _hoisted_31 = {
  key: 2,
  class: "localize"
}
const _hoisted_32 = {
  id: "menu-previous-elections",
  class: "previous-elections-wrapper collapse in",
  "aria-expanded": "true"
}
const _hoisted_33 = { class: "server-details-wrapper" }
const _hoisted_34 = {
  key: 0,
  id: "username"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "server-detials-title" }, "User: ", -1))
const _hoisted_36 = {
  key: 1,
  id: "username"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "server-detials-title" }, "Not logged in", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { id: "server-title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "server-detials-title" }, "Server: ", -1))
const _hoisted_41 = { id: "version" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "server-detials-title" }, "Version: ", -1))
const _hoisted_43 = { key: 2 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "server-detials-title" }, "QuickJoin: ", -1))
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clipboard" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TMPLabel = _resolveComponent("TMPLabel")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _hoisted_5,
          (!_ctx.store.electionsLoaded)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.store.electionsLoaded)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", {
                    class: _normalizeClass(`menu-server page-link ${_ctx.highlight('/')}`),
                    "data-page": "dashboard"
                  }, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Scientific Data")), 1)
                      ]),
                      _: 1
                    })
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.store.webPlugins.length > 0 && _ctx.store.electionsLoaded)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                (_ctx.store.webPlugins.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.webPlugins, (webPlugin) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: webPlugin.TypeName,
                          class: _normalizeClass(_ctx.highlight(`/plugin/${webPlugin.TypeName}`))
                        }, [
                          _createVNode(_component_router_link, {
                            to: `/plugin/${webPlugin.TypeName}`,
                            class: "previous-election",
                            "data-guid": webPlugin.TypeName
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(`plugin-font-awesome-icon ${webPlugin.FontAwesomeIcon}`)
                              }, null, 2),
                              _createElementVNode("span", null, _toDisplayString(webPlugin.MenuTitle), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "data-guid"])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.store.electionsLoaded)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      to: "/officials",
                      class: _normalizeClass(`menu-current-elected-officials ${_ctx.store.elections.titles.length ? '' : 'menu-no-link'}`)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        (_ctx.store.elections.titles.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("Elected Officials")), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.store.elections.titles.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("No Active Titles")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", {
                      class: _normalizeClass(`menu-running-elections ${_ctx.store.elections.running.length ? '' : 'menu-no-link'}`),
                      "data-toggle": "collapse",
                      "data-target": "#menu-running-elections"
                    }, [
                      _hoisted_21,
                      (_ctx.store.elections.running.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("Running Elections")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.store.elections.running.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                        : _createCommentVNode("", true),
                      (!_ctx.store.elections.running.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("No Running Elections")), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("ul", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.elections.running, (election) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `election${election.Id}`,
                          class: _normalizeClass(_ctx.highlight(`/election/${election.Id}`))
                        }, [
                          _createVNode(_component_router_link, {
                            to: `/election/${election.Id}`,
                            class: "running-election",
                            "data-guid": election.Id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TMPLabel, {
                                text: election.Name
                              }, null, 8, ["text"]),
                              (election.PendingVote)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["to", "data-guid"])
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_27, [
                    _createElementVNode("a", {
                      class: _normalizeClass(`menu-previous-elections ${_ctx.store.elections.past.length ? '' : 'menu-no-link'}`),
                      "data-toggle": "collapse",
                      "data-target": "#menu-previous-elections"
                    }, [
                      _hoisted_28,
                      (_ctx.store.elections.past.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("Previous Elections")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.store.elections.past.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                        : _createCommentVNode("", true),
                      (!_ctx.store.elections.past.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t("No Previous Elections")), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("ul", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.elections.past, (election) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `election${election.Id}`,
                          class: _normalizeClass(_ctx.highlight(`/election/${election.Id}`))
                        }, [
                          _createVNode(_component_router_link, {
                            to: `/election/${election.Id}`,
                            class: "previous-election",
                            "data-guid": election.Id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TMPLabel, {
                                text: election.Name
                              }, null, 8, ["text"])
                            ]),
                            _: 2
                          }, 1032, ["to", "data-guid"])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.store.username)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", null, _toDisplayString(_ctx.store.username), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38)),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_TMPLabel, {
                text: _ctx.store.serverInfo.Description
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("span", null, _toDisplayString(_ctx.store.serverInfo.Version), 1)
            ]),
            (_ctx.store.serverInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("a", {
                    id: "join-link",
                    href: _ctx.store.serverInfo.JoinUrl,
                    "data-toggle": "tooltip"
                  }, "Click here to join.", 8, _hoisted_45),
                  _hoisted_46,
                  _createElementVNode("a", {
                    id: "join-button",
                    "data-toggle": "tooltip",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                    title: "Click to copy QuickJoin link to clipboard"
                  }, _hoisted_48)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}